import {
  CreatePoliticalPartyRequest,
  PoliticalPartyResponse,
  UpdatePoliticalPartyRequest,
} from "../models/parties";
import { backend } from "../utils/axios";

const ROUTE = "/political-parties";

interface PartiesServiceEndpoints {
  createParty: (
    data: CreatePoliticalPartyRequest
  ) => Promise<PoliticalPartyResponse>;
  getParty: (partyId: string) => Promise<PoliticalPartyResponse>;
  getParties: () => Promise<PoliticalPartyResponse[]>;
  editParty: (
    partyId: string,
    data: UpdatePoliticalPartyRequest
  ) => Promise<PoliticalPartyResponse>;
  deleteParty: (partyId: string) => Promise<PoliticalPartyResponse>;
}

export const PartiesService: PartiesServiceEndpoints = {
  createParty: (data) =>
    backend
      .post<PoliticalPartyResponse>(ROUTE, data)
      .then(({ data }) => data)
      .catch(),
  getParty: (partyId) =>
    backend
      .get<PoliticalPartyResponse>(`${ROUTE}/${partyId}`)
      .then(({ data }) => data)
      .catch(),
  getParties: () =>
    backend
      .get<PoliticalPartyResponse[]>(ROUTE)
      .then(({ data }) => data)
      .catch(),
  editParty: (partyId, data) =>
    backend
      .put<PoliticalPartyResponse>(`${ROUTE}/${partyId}`, data)
      .then(({ data }) => data)
      .catch(),
  deleteParty: (partyId) =>
    backend
      .delete<PoliticalPartyResponse>(`${ROUTE}/${partyId}`)
      .then(({ data }) => data)
      .catch(),
};
